import { ClientAssets } from 'HiveClient/config/ClientAssets';
import { useTranslation } from 'react-i18next';

export const UnderMaintenance = () => {
  const { t } = useTranslation();

  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-gap-4'>
      <img
        src={ClientAssets.logo}
        alt='Logo'
        className='tw-w-64 tw-h-auto tw-object-cover'
      />
      <h1 className='tw-text-4xl'>{t('maintenance-screen.title')}</h1>
      <p className='tw-text-lg'>{t('maintenance-screen.description')}</p>
    </div>
  );
};
